import { CancelAppView } from "../views/CancelApp/CancelAppView";
import { StationMunicipalities } from "../views/StationMunicipalities/StationMunicipalities";
import DispenserUser from "../views/DispenserUser/DispenserUser";
import { CatalogsSync } from "../views/CatalogsSync/CatalogsSync";
import { ConfigTimePrice } from "../views/ConfigTimePrice/ConfigTimePrice";
import { SupportExpensesView } from "../views/supportExpenses/SupportExpensesView";
import { ConfigChange } from "views/ConfigChange/ConfigChangeView";
import { configChangeTypes } from "redux/reducers/configChange/types";
import { stationConfigurationsTypes } from "redux/reducers/stationConfigurations/types";
import { PERMISSIONS } from "router/permissions";
import HelpIcon from '@material-ui/icons/Help';
import { StationConfigurations } from "views/StationConfigurations/StationConfigurationsView";

const {
  SUPPORT,
  SUPPORT_APP,
  SUPPORT_MUNICIPALITIES,
  SUPPORT_DISPENSER_USER,
  SUPPORT_SYNC_CATALOG_APRO,
  SUPPORT_PRICES,
  SUPPORT_PERIOD_EXPENSES,
  SUPPORT_SGC_CHANGE_CONF,
  SUPPORT_STATIONS_CONFIGURATIONS_DIGITAL,
} = PERMISSIONS

const configChangeError = {
  reducer: "configChange",
  restoreKey: configChangeTypes.RESTORE_INITIAL
}
const configStationConfigError = {
  reducer: "stationConfig",
  restoreKey: stationConfigurationsTypes.RESTORE_INITIAL
}


export const supportRoutes = [
  {
    collapse: true,
    name: "Soporte",
    icon: HelpIcon,
    state: "SupportCollapse",
    inSidebar: true,
    isProtected: true,
    rule: SUPPORT,
    views: [
      {
        path: "/soporte-app",
        name: "Soporte App",
        mini: "SA",
        component: CancelAppView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: SUPPORT_APP,
      },
      {
        path: "/municipios",
        name: "Municipios",
        mini: "MU",
        component: StationMunicipalities,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: SUPPORT_MUNICIPALITIES,
      },
      {
        path: "/usuario-dispensador",
        name: "Usuario Dispensador",
        mini: "UD",
        component: DispenserUser,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: SUPPORT_DISPENSER_USER,
      },
      {
        path: "/sincronizacion-catalogos",
        name: "Catalogos Sync",
        mini: "CS",
        component: CatalogsSync,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: SUPPORT_SYNC_CATALOG_APRO,
      },
      {
        path: "/soporte-Config",
        name: "Soporte Configuraciones",
        mini: "SC",
        component: ConfigTimePrice,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: SUPPORT_PRICES,
      },
      {
        path: "/soporte-Gastos",
        name: "Soporte Gastos",
        mini: "SG",
        component: SupportExpensesView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: SUPPORT_PERIOD_EXPENSES,
      },
      {
        path: "/cambio-configuracion",
        name: "Cambio de Configuración",
        mini: "CC",
        component: ConfigChange,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: SUPPORT_SGC_CHANGE_CONF,
        ...configChangeError,
      },
      {
        path: "/planta-inv-digital",
        name: "Planta Inventario Dig.",
        mini: "PC",
        component: StationConfigurations,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: SUPPORT_STATIONS_CONFIGURATIONS_DIGITAL,
        ...configStationConfigError,
      },
    ],
  },
]